import { FC, useState } from 'react';
import { BaseLocation, useLocationService } from '../../services/location/LocationService';
import { LocationsCheckboxes } from '../../components/shared/checkboxes/LocationsCheckboxes';
import { Button } from '../../components/shared/button/Button';
import { commonStrings } from '../../services/translation/commonTranslations';
import { Modal } from '../../components/shared/modal/Modal';
import strings from './shifts.translations';

interface AllShiftsPageProps {
  onCompleteCallback: () => void;
  onClose: () => void;
  open: boolean;
}

export const UpdateSelectedLocationsModal: FC<AllShiftsPageProps> = ({ onCompleteCallback, onClose, open }) => {
  const setSelectedShiftLocations = useLocationService(state => state.setSelectedShiftLocations);
  const [selectedLocations, setSelectedLocations] = useState<BaseLocation[]>([]);

  const onComplete = () => {
    setSelectedShiftLocations(selectedLocations);
    onCompleteCallback();
  };

  return (
    <Modal open={open} onClose={onClose} header={strings.selectedLocationModalTitle} className="space-y-4">
      <LocationsCheckboxes onUpdate={locations => setSelectedLocations(locations)} />
      <Button className="sm:mr-3 w-full sm:w-auto" onClick={onClose}>
        {commonStrings.common.cancel}
      </Button>
      <Button primary className="w-full sm:w-auto" onClick={onComplete} loading={false}>
        {commonStrings.common.ok}
      </Button>
    </Modal>
  );
};
